module.exports = __webpack_public_path__ + "img/图1-32手柄平面图.596af142.jpg";